import { BoxProps } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';
import { Async } from '~/shared/tools/async';
import { AsyncView, AsyncViewProps } from '../view.async';
import { Col } from '../view.box';

export type GridContainerProps = BoxProps &
	PropsWithChildren<{ async: Async; slotsProps?: { async?: Omit<AsyncViewProps, 'async'> } }>;

export const GridContainer = observer<GridContainerProps>(({ async, children, slotsProps, ...props }) => {
	return (
		<Col mx={2} mt={1} height="calc(100vh - 72px);" width="100%" {...props}>
			<AsyncView async={async} withoutLoading {...slotsProps?.async}>
				{children}
			</AsyncView>
		</Col>
	);
});
